import React, { useEffect, useRef } from "react";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js"; 

const DelModal = ({isDelModal, handelDelete, delModalClose}) => {
  const delBtnRef = useRef(null);

  useEffect(() => {
    delBtnRef.current.focus();
  } ,[])
  return (
    <div className="w-full h-full fixed z-20">
      <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg px-5 w-[30%] h-[25%] z-10 items-center">
        <div className="modal-titleZone flex justify-between">
          <div className="modal-title">실험 결과 삭제</div>
          <button type="button" onClick={delModalClose} className="closeModal" style={{ padding: 0 }}>
            <Icon type="mdi" path={mdiClose} />
          </button>
        </div>
        <div className="modal-contentZone content-center">
          <div className="text-lg">실험 결과를 삭제하시겠습니까?</div>  
        </div>
        <div className="modal-btnZone flex gap-2 justify-end">
          <button ref={delBtnRef} onClick={handelDelete} className="delBtn">삭제</button>
          <button onClick={delModalClose} className="delCancelBtn">취소</button>
        </div>
      </div>
      <div className={`modalOverlay ${isDelModal ? 'active' : ''}`} onClick={delModalClose}></div>
    </div>
  )
}

export default DelModal;